import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ApplePayButton from "../apple-pay-button/ApplePayButton";
import DasCustomGpayButton from "../google-pay-button/DasCustomGpayButton";
import { DasGooglePayButton } from "../google-pay-button/DasGooglePayButton";
import DasORSeparator from "../apple-pay-button/components/DasORSeparator";
import { DasPayPayButton } from "../pay-pay-button/DasPayPayButton";
import { DasPayNowButton } from "../paynow-button/DasPayNowButton";
import { DasQrphButton } from "../qrph-button/DasQrphButton";
import { applePayController } from "../apple-pay-button/components/apple-pay";

const WalletButtons = ({
  isIbec = false,
  allTrue = false,
  apiData,
  setApiData,
  setAmountPopup,
  handleApplePayClick,
  slug,
  setDasLoader,
  onPayNowQrGenerated,
  onQrphQrGenerated,
}: any) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const applePaySessionAvailable = applePayController.isAppleSessionAvailable();

  // Apple Pay renders nothing when the session is unavailable and the card
  // form is enabled, so it must not count towards showing the wrapper.
  const showApplePay =
    apiData?.hasApplePay &&
    apiData?.buttons?.enableApplePay &&
    (applePaySessionAvailable || !apiData?.buttons?.enableCardPayment);
  const showGooglePay =
    apiData?.hasGooglePay && apiData?.buttons?.enableGooglePay;
  const showPayPay = apiData?.hasPayPay && apiData?.buttons?.enablePayPay;
  const showPayNow = apiData?.hasPayNow;
  const showQrph = apiData?.hasQRPH;

  if (!showApplePay && !showGooglePay && !showPayPay && !showPayNow && !showQrph) {
    return null;
  }

  const GpayApplePayAlignment =
    isIbec &&
    applePaySessionAvailable &&
    apiData?.hasApplePay &&
    apiData?.hasGooglePay
      ? "vertical-alignment"
      : "";

  return (
    <div className={`wallet-buttons ${GpayApplePayAlignment}`}>
      {isIbec && allTrue && (
        <div className="ibec-google-pay-apple-pay-title-text">
          <DasORSeparator
            text={"From The Button Below"}
            text2={"You Can Also Pay"}
          />
        </div>
      )}
      {isIbec &&
        !allTrue &&
        apiData?.hasApplePay &&
        apiData?.buttons?.enableApplePay && (
          <div
            className="ibec-google-pay-apple-pay-title-text mb-25"
            dangerouslySetInnerHTML={{
              __html: t("Enable Apple Pay Text"),
            }}
          />
        )}
      {isIbec &&
        !allTrue &&
        apiData?.hasGooglePay &&
        apiData?.buttons?.enableGooglePay && (
          <div
            className="ibec-google-pay-apple-pay-title-text mb-25"
            dangerouslySetInnerHTML={{
              __html: t("Enable Google Pay Text"),
            }}
          />
        )}
      <div className="wallet-apple-google-pay-buttons">
        {apiData?.hasApplePay && apiData?.buttons?.enableApplePay && (
          <ApplePayButton
            apiData={apiData}
            setApiData={setApiData}
            setAmountPopup={setAmountPopup}
            handleApplePayClick={handleApplePayClick}
          />
        )}

        {apiData?.hasGooglePay && apiData?.buttons?.enableGooglePay && (
          <>
            {!apiData?.amount ? (
              <DasCustomGpayButton
                slug={slug}
                apiData={apiData}
                setAmountPopup={setAmountPopup}
              />
            ) : (
              <DasGooglePayButton
                apiData={apiData}
                slug={slug}
                navigate={navigate}
                setDasLoader={setDasLoader}
              />
            )}
          </>
        )}
        {apiData?.hasPayPay && apiData?.buttons?.enablePayPay && (
          <DasPayPayButton
            apiData={apiData}
            setApiData={setApiData}
            setDasLoader={setDasLoader}
            slug={slug}
            setAmountPopup={setAmountPopup}
          />
        )}
        {apiData?.hasPayNow && (
          <DasPayNowButton
            apiData={apiData}
            slug={slug}
            setDasLoader={setDasLoader}
            setAmountPopup={setAmountPopup}
            onQrGenerated={onPayNowQrGenerated}
            navigate={navigate}
          />
        )}
        {apiData?.hasQRPH && (
          <DasQrphButton
            apiData={apiData}
            slug={slug}
            setDasLoader={setDasLoader}
            setAmountPopup={setAmountPopup}
            onQrGenerated={onQrphQrGenerated}
            navigate={navigate}
          />
        )}
      </div>
      {allTrue &&
        (apiData?.hasPayNow ||
          apiData?.hasQRPH ||
          apiData?.hasPayPay ||
          apiData?.hasGooglePay ||
          (apiData?.hasApplePay && applePaySessionAvailable)) && (
          <DasORSeparator />
        )}
    </div>
  );
};

export default WalletButtons;
